import CRUDReducer from './CRUDReducer';
import newsCRUDActions from '../actions/news';

const newsCRUDReducer = new CRUDReducer(newsCRUDActions);

export default (state, action) => newsCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/news.js